/* =============================================================
   FREEDOM UNIVERSITY — main.js
   Vanilla JS, zero dipendenze. Progressive enhancement:
   tutto il contenuto resta usabile anche con JS disattivato.
   ============================================================= */
(function () {
  "use strict";

  /* ----- 1. Navbar: stato scroll + menu mobile ----- */
  const nav = document.querySelector("[data-nav]");
  if (nav) {
    const toggle = nav.querySelector("[data-nav-toggle]");
    const onScroll = () => nav.classList.toggle("is-scrolled", window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    if (toggle) {
      toggle.addEventListener("click", () => {
        const open = nav.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", String(open));
        document.body.style.overflow = open ? "hidden" : "";
      });
      // chiudi al click su un link (mobile)
      nav.querySelectorAll(".nav__link").forEach((a) =>
        a.addEventListener("click", () => {
          nav.classList.remove("is-open");
          toggle.setAttribute("aria-expanded", "false");
          document.body.style.overflow = "";
        })
      );
    }
  }

  /* ----- 2. Scroll reveal via IntersectionObserver ----- */
  const reveals = document.querySelectorAll(".reveal");
  if (reveals.length) {
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("is-in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
      reveals.forEach((el) => io.observe(el));
    } else {
      reveals.forEach((el) => el.classList.add("is-in")); // fallback
    }
  }
  window.__fuRevealReady = true; // segnala al layout che le animazioni sono gestite

  /* ----- 3. Accordion (curriculum / FAQ) ----- */
  document.querySelectorAll("[data-accordion]").forEach((acc) => {
    const single = acc.hasAttribute("data-single"); // un solo pannello aperto
    acc.querySelectorAll(".acc-trigger").forEach((trigger) => {
      const item = trigger.closest(".acc-item");
      const panel = item.querySelector(".acc-panel");
      trigger.setAttribute("aria-expanded", item.classList.contains("is-open") ? "true" : "false");
      const setOpen = (open) => {
        item.classList.toggle("is-open", open);
        trigger.setAttribute("aria-expanded", String(open));
        panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
      };
      // init
      if (item.classList.contains("is-open")) panel.style.maxHeight = panel.scrollHeight + "px";
      trigger.addEventListener("click", () => {
        const willOpen = !item.classList.contains("is-open");
        if (single && willOpen) {
          acc.querySelectorAll(".acc-item.is-open").forEach((openItem) => {
            openItem.classList.remove("is-open");
            openItem.querySelector(".acc-trigger").setAttribute("aria-expanded", "false");
            openItem.querySelector(".acc-panel").style.maxHeight = "0px";
          });
        }
        setOpen(willOpen);
      });
    });
    // ricalcola altezza su resize (responsive)
    window.addEventListener("resize", () => {
      acc.querySelectorAll(".acc-item.is-open .acc-panel").forEach((p) => {
        p.style.maxHeight = p.scrollHeight + "px";
      });
    });
  });

  /* ----- 4. Counter animati ----- */
  const counters = document.querySelectorAll("[data-count]");
  if (counters.length && "IntersectionObserver" in window) {
    const fmt = (n, dec) => n.toLocaleString("it-IT", { minimumFractionDigits: dec, maximumFractionDigits: dec });
    const animate = (el) => {
      const target = parseFloat(el.dataset.count);
      const dec = (el.dataset.count.split(".")[1] || "").length;
      const prefix = el.dataset.prefix || "";
      const suffix = el.dataset.suffix || "";
      const dur = 1400;
      let start;
      const step = (ts) => {
        if (!start) start = ts;
        const p = Math.min((ts - start) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        el.textContent = prefix + fmt(target * eased, dec) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = prefix + fmt(target, dec) + suffix;
      };
      requestAnimationFrame(step);
    };
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            animate(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    counters.forEach((el) => io.observe(el));
  }

  /* ----- 5. Validazione form (client-side, demo) ----- */
  document.querySelectorAll("[data-form]").forEach((form) => {
    const success = form.parentElement.querySelector("[data-form-success]");
    const showError = (field, on) => field.classList.toggle("has-error", on);

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      let valid = true;
      form.querySelectorAll("[required]").forEach((input) => {
        const field = input.closest(".field");
        let ok = input.value.trim() !== "";
        if (ok && input.type === "email") ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value);
        showError(field, !ok);
        if (!ok) valid = false;
      });
      if (!valid) {
        const firstErr = form.querySelector(".has-error .input, .has-error .select, .has-error .textarea");
        if (firstErr) firstErr.focus();
        return;
      }
      // DEMO: nessun invio reale. In Shopify si collega a form action / app form.
      // Se il form ha data-redirect, porta alla thank-you page (funnel + tracking conversione).
      var redirect = form.getAttribute("data-redirect");
      if (redirect) { window.location.href = redirect; return; }
      form.style.display = "none";
      if (success) {
        success.classList.add("is-visible");
        success.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      // eslint-disable-next-line no-console
      console.info("[FU] Form valido — pronto per integrazione backend/Shopify.", Object.fromEntries(new FormData(form)));
    });

    // pulisci errore mentre l'utente digita
    form.querySelectorAll("input, select, textarea").forEach((input) =>
      input.addEventListener("input", () => input.closest(".field")?.classList.remove("has-error"))
    );
  });

  /* ----- 6. Anno corrente nel footer ----- */
  document.querySelectorAll("[data-year]").forEach((el) => (el.textContent = new Date().getFullYear()));

  /* ----- 6b. Sticky CTA mobile: compare dopo l'hero ----- */
  var stickyCta = document.querySelector("[data-sticky-cta]");
  if (stickyCta) {
    var heroEl = document.querySelector(".hero, .cand-hero");
    var ctaTrigger = heroEl ? heroEl.offsetHeight * 0.8 : 600;
    var onScrollCta = function () { stickyCta.classList.toggle("is-in", window.scrollY > ctaTrigger); };
    onScrollCta();
    window.addEventListener("scroll", onScrollCta, { passive: true });
  }

  /* ----- 7. Cookie banner GDPR + gate embed di terze parti ----- */
  // Gli embed di terze parti (YouTube/IG/TikTok) hanno l'src reale in data-consent-src
  // e vengono caricati SOLO dopo il consenso. Conforme GDPR.
  var CONSENT_KEY = "fu_cookie_consent";
  function loadConsentedEmbeds() {
    document.querySelectorAll("[data-consent-src]").forEach(function (el) {
      if (!el.getAttribute("src")) el.setAttribute("src", el.getAttribute("data-consent-src"));
    });
    // rimuovi gli overlay "bloccato" una volta dato il consenso
    document.querySelectorAll(".embed-locked").forEach(function (el) { el.style.display = "none"; });
  }
  function getConsent() { try { return localStorage.getItem(CONSENT_KEY); } catch (e) { return null; } }
  function setConsent(v) { try { localStorage.setItem(CONSENT_KEY, v); } catch (e) {} }

  if (getConsent() === "accept") {
    loadConsentedEmbeds();
  } else if (getConsent() !== "reject") {
    // mostra banner
    var banner = document.createElement("div");
    banner.className = "cookie-banner";
    banner.setAttribute("role", "dialog");
    banner.setAttribute("aria-label", "Preferenze cookie");
    banner.innerHTML =
      '<p>Usiamo cookie tecnici e, previo consenso, contenuti di terze parti (video, recensioni, social) che possono installare cookie. Leggi la <a href="#">privacy policy</a>.</p>' +
      '<div class="cookie-banner__actions">' +
      '<button class="btn btn--ghost" data-cookie="reject">Rifiuta</button>' +
      '<button class="btn btn--primary" data-cookie="accept">Accetta</button>' +
      "</div>";
    document.body.appendChild(banner);
    requestAnimationFrame(function () { banner.classList.add("is-visible"); });
    banner.addEventListener("click", function (e) {
      var choice = e.target.getAttribute("data-cookie");
      if (!choice) return;
      setConsent(choice);
      if (choice === "accept") loadConsentedEmbeds();
      banner.classList.remove("is-visible");
      setTimeout(function () { banner.remove(); }, 400);
    });
  }
})();

/* ============================================================
   FU — UTM CAPTURE & PROPAGATION (tracking lead)
   Cattura gli UTM dall'URL, li persiste, li propaga ai form Tally
   e ai link di candidatura. Pronto per Make/CAPI lato server.
   ============================================================ */
(function(){
  "use strict";
  var UTM_KEYS = ["utm_source","utm_medium","utm_campaign","utm_content","utm_term",
                  "campaign_id","adset_id","ad_id","fbclid","ttclid","gclid"];
  // Chiavi tracking aggiuntive per il match Meta CAPI (lato server via Make).
  // Queste NON arrivano dall'URL: si leggono dai cookie del pixel / dal browser
  // e si iniettano in Tally come hidden field, così la webhook le inoltra a Make.
  var TRACK_KEYS = ["fbp","fbc","client_user_agent","event_source_url"];
  var STORE_KEY = "fu_utms";

  function getParams(){
    var p = new URLSearchParams(window.location.search), out = {};
    UTM_KEYS.forEach(function(k){ if(p.get(k)) out[k] = p.get(k); });
    return out;
  }
  function load(){ try { return JSON.parse(sessionStorage.getItem(STORE_KEY)||"{}"); } catch(e){ return {}; } }
  function save(o){ try { sessionStorage.setItem(STORE_KEY, JSON.stringify(o)); } catch(e){} }
  function getCookie(name){
    var m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return m ? decodeURIComponent(m.pop()) : "";
  }

  // 1) merge UTM dall'URL con quelli già salvati (first-touch persistito in sessione)
  var fromUrl = getParams();
  var stored = load();
  var utms = Object.assign({}, stored, fromUrl);
  // metadati utili
  if(!utms.landing_page) utms.landing_page = window.location.pathname;
  if(Object.keys(fromUrl).length) utms.first_seen = utms.first_seen || new Date().toISOString();
  save(utms);

  // 1b) arricchimento tracking lato browser (per CAPI). Idempotente: si può
  //     richiamare più volte, i cookie del pixel (_fbp/_fbc) arrivano async.
  function enrichTracking(){
    var fbp = getCookie("_fbp");
    var fbc = getCookie("_fbc");
    // se manca _fbc ma c'è fbclid, ricostruisco il formato Meta: fb.1.<ts>.<fbclid>
    if(!fbc && (utms.fbclid)){
      fbc = "fb.1." + Date.now() + "." + utms.fbclid;
    }
    if(fbp) utms.fbp = fbp;
    if(fbc) utms.fbc = fbc;
    if(!utms.client_user_agent) utms.client_user_agent = navigator.userAgent;
    if(!utms.event_source_url) utms.event_source_url = window.location.href;
    save(utms);
  }
  enrichTracking();

  // 2) costruisci query string (UTM + tracking) — solo chiavi conosciute, ordine stabile
  function trackQuery(){
    var parts = [];
    UTM_KEYS.concat(TRACK_KEYS, ["landing_page","first_seen"]).forEach(function(k){
      if(utms[k]) parts.push(encodeURIComponent(k)+"="+encodeURIComponent(utms[k]));
    });
    return parts.join("&");
  }

  // 3) propaga gli UTM ai link interni di candidatura/percorsi (così passano di pagina).
  //    Sui link NON propago i campi tecnici lunghi (UA/fbc) per non sporcare gli URL:
  //    quelli servono solo dentro Tally. Sui link passano solo UTM + click-id.
  function linkQuery(){
    var parts = [];
    UTM_KEYS.forEach(function(k){
      if(utms[k]) parts.push(encodeURIComponent(k)+"="+encodeURIComponent(utms[k]));
    });
    return parts.join("&");
  }
  function appendUtmToLinks(){
    var q = linkQuery(); if(!q) return;
    document.querySelectorAll('a[href^="/pages/"], a[href^="/"]').forEach(function(a){
      var href = a.getAttribute("href");
      if(!href || href.indexOf("#")===0 || href.indexOf("mailto:")===0 || href.indexOf("tel:")===0) return;
      if(href.indexOf("utm_")>-1) return; // già presente
      a.setAttribute("href", href + (href.indexOf("?")>-1 ? "&" : "?") + q);
    });
  }

  // 4) prefill dei form Tally via query string (Tally legge i parametri come hidden field).
  //    Differito: il cookie _fbp del pixel e l'iframe Tally (embed.js async) arrivano dopo.
  //    Guard per-iframe: inietto una sola volta (re-set di src ricaricherebbe il form).
  function injectUtmIntoTally(){
    enrichTracking();
    var q = trackQuery(); if(!q) return;
    document.querySelectorAll('iframe[data-tally-src], iframe[src*="tally.so/embed"]').forEach(function(f){
      if(f.getAttribute("data-fu-tracked")) return;
      var base = f.getAttribute("data-tally-src") || f.getAttribute("src");
      if(!base) return;
      if(base.indexOf("utm_")>-1 || base.indexOf("client_user_agent")>-1){ f.setAttribute("data-fu-tracked","1"); return; }
      var url = base + (base.indexOf("?")>-1 ? "&" : "?") + q;
      if(f.getAttribute("data-tally-src")) f.setAttribute("data-tally-src", url);
      else f.setAttribute("src", url);
      f.setAttribute("data-fu-tracked","1");
    });
  }

  // i link si possono propagare subito; l'iniezione Tally va differita (fbp + iframe mount)
  function runLinks(){ appendUtmToLinks(); }
  if(document.readyState!=="loading") runLinks();
  else document.addEventListener("DOMContentLoaded", runLinks);
  // l'iniezione Tally parte a 1200ms (fbp pronto) e ritenta per iframe a montaggio tardivo
  setTimeout(injectUtmIntoTally, 1200);
  setTimeout(injectUtmIntoTally, 2500);
  setTimeout(injectUtmIntoTally, 4000);
})();

/* ============================================================
   FU — Card tilt 3D premium (leggero, solo desktop, reduced-motion safe)
   ============================================================ */
(function(){
  "use strict";
  if(!window.matchMedia) return;
  if(!matchMedia("(hover:hover) and (pointer:fine)").matches) return;
  if(matchMedia("(prefers-reduced-motion:reduce)").matches) return;
  var MAX = 4; // gradi massimi (sobrio)
  var cards = document.querySelectorAll(".fu-landing .card--hover");
  cards.forEach(function(c){
    var raf = null;
    c.addEventListener("pointerenter", function(){ c.style.transition = "transform .06s linear"; });
    c.addEventListener("pointermove", function(e){
      var r = c.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      if(raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        c.style.transform = "perspective(900px) translateY(-7px) rotateX(" + (-py*MAX).toFixed(2) + "deg) rotateY(" + (px*MAX).toFixed(2) + "deg)";
        // spotlight che segue il cursore (radial gradient via CSS ::after)
        c.style.setProperty("--mx", ((e.clientX - r.left)/r.width*100).toFixed(1) + "%");
        c.style.setProperty("--my", ((e.clientY - r.top)/r.height*100).toFixed(1) + "%");
      });
    });
    c.addEventListener("pointerleave", function(){
      if(raf) cancelAnimationFrame(raf);
      c.style.transition = "";
      c.style.transform = "";
    });
  });
})();
// v=1780500000